import { render, staticRenderFns } from "./bimEditorJS.vue?vue&type=template&id=de38ebf8&scoped=true&"
import script from "./bimEditorJS.vue?vue&type=script&lang=js&"
export * from "./bimEditorJS.vue?vue&type=script&lang=js&"
import style0 from "./bimEditorJS.vue?vue&type=style&index=0&id=de38ebf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de38ebf8",
  null
  
)

export default component.exports